import axios from 'axios';
import Cookies from 'js-cookie';
/**
 * Gérer l'intéractivité des recherches.
 *
 * @export
 * @class Search
 */
export default class Search {
    vehicleSearchForm;
    vinSearchForm;
    partNumberSearchForm;
    advancedSearchForm;
    btnVehicleSearch;
    btnPartNumberSearch;
    btnAdvancedSearch;
    vehicleSearch;
    year;
    make;
    model;
    submodel;
    motorization;
    vin;
    search;
    backButtons;
    partNumber;
    line;
    /**
     * Créer une instance de Search.
     *
     * @param {HTMLFormElement} VehicleSearchForm Le formulaire de recherche par véhicule.
     * @memberof Search
     */
    constructor(vehicleSearchForm, vinSearchForm, partNumberSearchForm, advancedSearchForm) {
        this.vehicleSearchForm = vehicleSearchForm;
        this.vinSearchForm = vinSearchForm;
        this.partNumberSearchForm = partNumberSearchForm;
        this.advancedSearchForm = advancedSearchForm;
        this.btnVehicleSearch = document.getElementById('btn-vehicle-search');
        this.btnPartNumberSearch = document.getElementById('btn-part-number-search');
        this.btnAdvancedSearch = document.getElementById('btn-advanced-search');
        this.vehicleSearch = document.getElementById('vehicle-search');
        this.year = document.getElementById('vehicle-search-year');
        this.make = document.getElementById('vehicle-search-make');
        this.model = document.getElementById('vehicle-search-model');
        this.submodel = document.getElementById('vehicle-search-submodel');
        this.motorization = document.getElementById('vehicle-search-motorization');
        this.vin = document.getElementById('vin-search-vin');
        this.search = document.getElementById('vehicle-search-search-btn');
        this.backButtons = document.getElementsByClassName('btn--search-back');
        this.partNumber = document.getElementById('part-number-search-part-number');
        this.line = document.getElementById('advanced-search-line');
        this.ajouterListeners();
        this.initRecherche();
    }
    /**
     * Ajouter les listeners.
     *
     * @private
     * @memberof Search
     */
    ajouterListeners() {
        [this.btnVehicleSearch, this.btnPartNumberSearch, this.btnAdvancedSearch].forEach((btn) => {
            btn.addEventListener("click", (ev) => {
                this.handleSearchTypeClick(btn);
                ev.stopPropagation();
            });
        });
        this.vehicleSearchForm.addEventListener('submit', (ev) => {
            ev.preventDefault();
            this.handleVehicleSearchFormSubmit();
        });
        this.year.addEventListener('change', () => { this.handleYearChange(); });
        this.make.addEventListener('change', () => { this.handleMakeChange(); });
        this.model.addEventListener('change', () => { this.handleModelChange(); });
        this.submodel.addEventListener('change', () => { this.handleSubmodelChange(); });
        this.vinSearchForm.addEventListener('submit', (ev) => {
            ev.preventDefault();
            this.sauvegarderRecherche('vin', { vin: this.vin.value.toUpperCase() });
            grecaptcha.execute(); // Soumission du formulaire via fonction googleRecaptchaOnSubmit définie dans app.ts.
        });
        this.search.addEventListener('click', () => { this.handleSearchClick(); });
        Array.from(this.backButtons).forEach((btn) => {
            btn.addEventListener('click', () => { this.handleBackButtonClick(); });
        });
        this.partNumberSearchForm.addEventListener('submit', () => {
            this.sauvegarderRecherche('part-number', { 'part-number': this.partNumber.value.toUpperCase() });
        });
        this.advancedSearchForm.addEventListener('submit', () => {
            this.sauvegarderRecherche('advanced', { line: this.line.value });
        });
    }
    /**
     * Initier la recherche.
     *
     * @private
     * @memberof Search
     */
    initRecherche() {
        const cookie = Cookies.get('spectra-premium-electronic-catalog-last-search');
        if (cookie) {
            const parsedCookie = JSON.parse(cookie);
            switch (parsedCookie.nomRecherche) {
                case 'vehicule':
                    this.btnVehicleSearch.click();
                    this.year.value = parsedCookie.data.year;
                    this.handleYearChange(parsedCookie.data);
                    break;
                case 'vin':
                    this.btnVehicleSearch.click();
                    this.vin.value = parsedCookie.data.vin;
                    break;
                case 'part-number':
                    this.btnPartNumberSearch.click();
                    this.partNumber.value = parsedCookie.data['part-number'];
                    break;
                case 'advanced':
                    this.btnAdvancedSearch.click();
                    this.line.value = parsedCookie.data.line;
                    break;
                default:
                    this.btnVehicleSearch.click();
                    break;
            }
        }
        else {
            this.btnVehicleSearch.click();
        }
        if (window.innerWidth < 768) {
            this.handleBackButtonClick();
        }
    }
    /**
     * Gérer un click sur l'un des boutons recherche (Vehicle + VIN | Part # | Advanced)­.
     *
     * @private
     * @param {HTMLButtonElement} btn Un bouton.
     * @memberof Search
     */
    handleSearchTypeClick(btn) {
        this.handleBackButtonClick();
        // 🤮🤮
        btn.classList.add('search__search--active');
        this[btn.dataset.search].classList.add('active-search');
    }
    /**
     * Gérer un click sur l'un des boutons "back".
     *
     * @private
     * @memberof Search
     */
    handleBackButtonClick() {
        const exSearchBtn = document.querySelector('.search__search--active');
        if (exSearchBtn instanceof HTMLButtonElement) {
            // 🤮
            exSearchBtn.classList.remove('search__search--active');
            this[exSearchBtn.dataset.search].classList.remove('active-search');
        }
    }
    /**
     * Gérer un changement d'année.
     *
     * @private
     * @param {Record<string, string>} [data]
     * @memberof Search
     */
    handleYearChange(data) {
        axios
            .get('/en/vehicules/get-makes.json', { params: { year: this.year.value } })
            .then((response) => {
            this.clearValues('year');
            for (const model in response.data) {
                this.make.add(new Option(model, model));
            }
            if (data) {
                this.make.value = data.make;
                this.handleMakeChange(data);
            }
            else {
                this.make.focus();
            }
        });
    }
    /**
     * Gérer un changement de manufacturier.
     *
     * @private
     * @param {Record<string, string>} [data]
     * @memberof Search
     */
    handleMakeChange(data) {
        axios
            .get('/en/vehicules/get-models.json', {
            params: {
                year: this.year.value,
                make: this.make.value
            }
        })
            .then((response) => {
            this.clearValues('make');
            for (const make in response.data) {
                this.model.add(new Option(make, make));
            }
            if (data) {
                this.model.value = data.model;
                this.handleModelChange(data);
            }
            else {
                this.model.focus();
            }
        });
    }
    /**
     * Gérer un changement de modèle.
     *
     * @private
     * @param {Record<string, string>} [data]
     * @memberof Search
     */
    handleModelChange(data) {
        axios
            .get('/en/vehicules/get-submodels.json', {
            params: {
                year: this.year.value,
                make: this.make.value,
                model: this.model.value
            }
        })
            .then((response) => {
            this.clearValues('model');
            response.data.forEach((vehicule) => {
                this.submodel.add(new Option(`${vehicule.submodel} ${vehicule.engtype} ${vehicule.liter}L`, vehicule.vehiculeIds));
            });
            if (data) {
                this.submodel.value = data.submodel;
                this.handleSubmodelChange(data);
            }
            else {
                this.submodel.focus();
            }
        });
    }
    /**
     * Gérer un changement de sous-modèle.
     *
     * @private
     * @param {Record<string, string>} [data]
     * @memberof Search
     */
    handleSubmodelChange(data) {
        const vehiculeIds = this.submodel.value;
        const inputContainer = this.motorization.parentElement;
        if (!vehiculeIds.includes(',')) {
            this.motorization.required = false;
            inputContainer.style.display = 'none';
            return;
        }
        this.motorization.required = true;
        inputContainer.style.display = 'block';
        axios
            .get('/en/vehicules/get-motorizations.json', { params: { vehiculeIds: vehiculeIds } })
            .then((response) => {
            this.clearValues('submodel');
            response.data.forEach((vehicule) => {
                this.motorization.add(new Option(`${vehicule.fuel} ${vehicule.fueldel} ${vehicule.asp} ${vehicule.engvin} ${vehicule.engdesg}`, vehicule.vehicule_id));
            });
            if (data) {
                this.motorization.value = data.motorization;
            }
            else {
                this.motorization.focus();
            }
        });
    }
    /**
     * Gérer la soumission du formulaire de recherche par véhicule.
     *
     * @private
     * @memberof Search
     */
    handleVehicleSearchFormSubmit() {
        const vehicleId = this.motorization.value || this.submodel.value;
        if (!vehicleId || vehicleId.includes(',')) { // Un ou plusieurs champ(s) vide(s).
            const errorMessage = this.vehicleSearchForm.dataset.errorMessage;
            Array.from(this.vehicleSearchForm.elements).forEach((element) => {
                if (!(element instanceof HTMLSelectElement))
                    return;
                element.setCustomValidity(''); // Nettoyer entre les tentatives de soumission.
                if (!element.value) {
                    element.setCustomValidity(errorMessage);
                }
            });
            this.vehicleSearchForm.reportValidity();
            return;
        }
        this.sauvegarderRecherche('vehicule', {
            year: this.year.value,
            make: this.make.value,
            model: this.model.value,
            submodel: this.submodel.value,
            motorization: this.motorization.value
        });
        window.location.href = `/${document.documentElement.lang}/vehicles/${vehicleId}/parts`;
    }
    /**
     * Gérer un click sur le bouton de recherche (recherche par véhicule).
     *
     * @private
     * @memberof Search
     */
    handleSearchClick() {
        if (this.vin.value) {
            this.sauvegarderRecherche('vin', { vin: this.vin.value.toUpperCase() });
            grecaptcha.execute(); // Soumission du formulaire via fonction googleRecaptchaOnSubmit définie dans app.ts.
        }
        else {
            this.handleVehicleSearchFormSubmit();
        }
    }
    /**
     * Sauvegarder une recherche.
     *
     * @private
     * @param {string} nomRecherche
     * @param {Record<string, unknown>} data
     * @memberof Search
     */
    sauvegarderRecherche(nomRecherche, data) {
        Cookies.set('spectra-premium-electronic-catalog-last-search', JSON.stringify({ nomRecherche: nomRecherche, data: data }), { expires: 365 });
    }
    /**
     * Effacer les valeurs make / model / submodel / motorization en fonction de l'option modifiée.
     *
     * Par exemple, un changement de make engendre un nettoyage de model, submodel et motorization.
     *
     * @private
     * @param {string} from L'option modifiée.
     * @memberof Search
     */
    clearValues(from) {
        let proprieteTrouvee = false;
        const proprietes = {
            year: this.year,
            make: this.make,
            model: this.model,
            submodel: this.submodel,
            motorization: this.motorization
        };
        for (const [key, value] of Object.entries(proprietes)) {
            if (proprieteTrouvee) {
                value.options.length = 1;
            }
            if (key == from) {
                proprieteTrouvee = true;
                this.vin.value = '';
            }
        }
    }
}
